// src/com/sms_phrases/SmsPhrasesGql.js
import { gql } from "@apollo/client";

/* ************************************************
 * SMS_PHRASES Apollo Graphql
 * SMS 메시지를 보낼때 자주 사용하는 문구
 * Project: NewTOP for cloud
 * 2025-01-24 15:24:53 using DbdbTap.
 * https://www.dbdbtap.com
 ************************************************ */

const SMS_PHRASES_LIST_PART = gql`
fragment SmsPhrasesListPart on SmsPhrases {
    smsPhrasesSeq
    dscId
    userId
    phrase
    regUser
    regDate
    userName
}
`;



export const LIST_SMS_PHRASES = gql`
${SMS_PHRASES_LIST_PART}
query ListSmsPhrases {
    smsPhrasesList {
        ...SmsPhrasesListPart
    }
}
`;

export const GET_SMS_PHRASES = gql`
${SMS_PHRASES_LIST_PART}
query GetSmsPhrases($smsPhrasesSeq:Int!) {
    smsPhrasesItem(smsPhrasesSeq:$smsPhrasesSeq) {
        ...SmsPhrasesListPart
    }
}
`;

export const ADD_SMS_PHRASES = gql`
mutation AddSmsPhrases($smsPhrases:InputSmsPhrasesAdd!) {
	smsPhrasesAdd(smsPhrases: $smsPhrases) {
		ok
		message
	}
}
`;

export const EDIT_SMS_PHRASES = gql`
mutation EditSmsPhrases($smsPhrases:InputSmsPhrasesEdit!) {
	smsPhrasesEdit(smsPhrases: $smsPhrases) {
		ok
		message
	}
}
`;

export const REMOVE_SMS_PHRASES = gql`
mutation RemoveSmsPhrases($smsPhrases:InputSmsPhrasesRemove!) {
	smsPhrasesRemove(smsPhrases: $smsPhrases) {
		ok
		message
	}
}
`;
